import { EventViewProgramPageContent } from 'components/eventView/pages/EVProgramPageContent';
import { EmbedProgramHeader } from 'pages/custom/embed/EmbedProgramHeader';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    contentRef?: React.RefCallback<HTMLDivElement>;
}

export const EmbedProgramPage = (props: Props): JSX.Element => {
    return (
        <S_EmbedProgramPage className={props.className} ref={props.contentRef}>
            <EmbedProgramHeader />
            <EventViewProgramPageContent />
        </S_EmbedProgramPage>
    );
};

const S_EmbedProgramPage = styled.div`
    width: 100%;
    padding-top: 30px;
    max-width: 700px;
    margin: 0 auto;
`;
